import React from 'react';
import { PROCESS_STEPS } from '../data/processSteps';
import { Icon } from './icons';

export default function ProcessFlow() {
  return (
    <section className="section">
      <div className="container">
        <h2 className="section-title">작업 프로세스</h2>
        <p className="section-subtitle">
          체계적인 4단계 프로세스로 완벽한 세차를 제공합니다
        </p>
        <div className="process-flow">
          {PROCESS_STEPS.map((step, i) => (
            <React.Fragment key={step.id}>
              <div className="process-step">
                <div className="process-step-icon" style={{ color: 'var(--primary)', display: 'flex', justifyContent: 'center' }}>
                  <Icon name={step.icon} size={32} />
                </div>
                <div className="process-step-label">{step.step}</div>
                <div className="process-step-name">{step.label}</div>
                <div className="process-step-desc">
                  {step.desc.map((line, j) => {
                    // 괄호로 시작하는 부가 안내('(모든 메뉴 기본 포함)')는 흐리게.
                    const isNote = line.startsWith('(');
                    return (
                      <div key={j} style={isNote ? { color: 'var(--text-dim)', fontSize: '0.92em', marginTop: 2 } : undefined}>
                        {line}
                      </div>
                    );
                  })}
                </div>
              </div>
              {i < PROCESS_STEPS.length - 1 && (
                <div className="process-arrow" style={{ color: 'var(--text-dim)' }}>
                  <Icon name="ChevronRight" size={24} />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}
